import React from "react";
import { useMutation } from "react-query";
import { updateOfficeAccount } from "../../../../../actions/Utilities/OfficeAccount";
import { toast } from "../../../../../components/toastNotification";
import { OfficeAccountType } from "../types";
import { editStateOfficeAccount, officeAccountReFetching } from "../atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

export default function useUpdateOfficeAccount() {
  const setActionEditState = useSetRecoilState(editStateOfficeAccount);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeAccountReFetching
  );
  
  const { mutate } = useMutation(
    (OfficeAccount: OfficeAccountType) => updateOfficeAccount(OfficeAccount),
    {
      onSuccess: (res) => {
        switch (res) {
          case "Success":
            toast.fire(
              "Success",
              "Office Account Updated Successfully",
              "success"
            );
            break;
          case "Notification insert Failed!":
            toast.fire(
              "Success ",
              `Office Account Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case "Operation Failed!":
            toast.fire(
              "Updating Office Account failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case "The data already exists!":
            toast.fire(
              "Updating Office Account failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
            case "Office Account not found":
            toast.fire(
                "Updating Office Account failed ",
                `Error: ${res}`,
                "error"
            );
            break;
            case "Action object is null":
            toast.fire(
                "Updating Office Account failed ",
                `Error: ${res}`,
                "error"
            );
            break;
          default:
            toast.fire(
              "Updating Office Account failed",
              `${res.Message}`,
              "error"
            );
        }
        
        // Redirect to View
        setActionEditState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Office Account failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
}
